import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import * as Text from "@/components/text";
import Flicking from "@egjs/react-flicking";
import "@egjs/react-flicking/dist/flicking.css";
import qs from "qs";
import useSWR from "swr";
import apiClient from "@/utils/apiClient";
import AnchorChip from "@/components/lib/AnchorChip";
import useWindowSize from "@/hooks/useWindowSize";
import Image from "next/image";
import Link from "next/link";
import { ArrowRightIcon } from "@heroicons/react/outline";
import Button from "@/components/actions/Button";

export default function PreviousEditions() {
  const windowSize = useWindowSize();
  const flickingRef = useRef(null);
  const [indexFlicking, setIndexFlicking] = useState(0);

  const handleChangeIndex = (index) => {
    setIndexFlicking(index);
    flickingRef.current.forceUpdate();
  };

  const q = qs.stringify({
    populate: {
      background_image: "*",
    },
    sort: ["name:desc"],
  });

  const fetcher = (url) => apiClient.get(url).then((res) => res.data);
  const { data, error, mutate } = useSWR(
    `/api/ediciones-ambulante-presentas?${q}`,
    fetcher
  );
  const editions = data?.data;

  const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  return (
    <>
      {editions && (
        <div className="mb-8 md:mb-0 lg:mt-20">
          <div className="pb-2 text-center lg:amb-container lg:text-left">
            <Text.Headline className="text-2xl font-light lg:text-[40px]">
              Ediciones anteriores
            </Text.Headline>
          </div>
          <>
            <div className="w-full lg:amb-container">
              <Flicking
                ref={flickingRef}
                moveType="freeScroll"
                className="py-2 md:py-0 md:pb-8 md:pt-4"
                align="prev"
                viewportTag="div"
                cameraTag="div"
                shouldHoldToMove={true}
              >
                {editions?.map((edition, i) => (
                  <div
                    key={i}
                    className="px-1"
                    onClick={() => handleChangeIndex(i)}
                  >
                    <AnchorChip active={indexFlicking === i}>
                      AP {edition?.attributes?.name}
                    </AnchorChip>
                  </div>
                ))}
              </Flicking>
            </div>
          </>
          <motion.div
            key={indexFlicking}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <div className="md:flex md:justify-center">
              <div className="mb-3 mt-6 flex h-[259px] w-full items-center justify-center md:mt-0 md:h-[360px] md:w-fit md:px-8 lg:mb-5 lg:mr-8 lg:h-[533px] lg:px-0">
                <Image
                  width={633}
                  height={1200}
                  className="h-full w-[184px] object-cover md:w-[256px] lg:w-[381px]"
                  alt="Edition image"
                  src={
                    editions[indexFlicking]?.attributes?.background_image?.data
                      ?.attributes?.url
                  }
                />
              </div>
              <div>
                <div className="text-center md:text-left">
                  <Text.Headline
                    as="p"
                    className="pb-1 text-[28px] font-bold lg:text-[36px]"
                  >
                    Ambulante Presenta (
                    {editions[indexFlicking]?.attributes?.name})
                  </Text.Headline>
                  <Text.Headline
                    as="p"
                    className="text-xl font-bold lg:text-[24px]"
                  >
                    {
                      months[
                      new Date(
                        editions[indexFlicking]?.attributes?.start_date
                      ).getMonth()
                      ]
                    } a&nbsp;
                    {months[
                      new Date(
                        editions[indexFlicking]?.attributes?.end_date
                      ).getMonth()
                    ].toLowerCase()}
                  </Text.Headline>
                </div>
                <div className="px-4 pb-4 md:w-[328px] md:px-0 lg:w-[561px]">
                  <Text.Headline
                    as="p"
                    className="md:text-md text-center text-sm font-semibold sm:leading-[22px] md:text-left  lg:text-lg"
                  >
                    {editions[indexFlicking]?.attributes?.subtitle}
                  </Text.Headline>
                  <Text.Headline
                    as="p"
                    className="mt-2 text-center text-lg font-medium leading-[24px] md:text-left md:leading-[26px] lg:mt-8"
                  >
                    {editions[indexFlicking]?.attributes?.description}
                  </Text.Headline>
                </div>
                <div className="flex items-center justify-center w-full mt-6 mb-8 md:mb-16 md:mt-10 lg:mb-28 lg:mt-20">
                  <Link
                    passHref
                    href={`/catalogo?eap=${editions[indexFlicking]?.attributes?.name}`}
                    className="flex justify-center w-full px-4 md:justify-start md:px-0"
                  >
                    <Button
                      size="lg"
                      color="secondary-light"
                      label="Ver catálogo de películas"
                      className="w-full font-bold md:w-fit md:px-[60px]"
                      trailingIcon={<ArrowRightIcon />}
                    ></Button>
                  </Link>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </>
  );
}
